<template>
  <div class="main">
    <c-panel title="Monitor" titleIcon="fas fa-user-check">
      <form-monitor :paramId="id" @onSubmitMonitor="afterSubmit"></form-monitor>
    </c-panel>
  </div>
</template>

<script>
import formMonitor from "./form"

export default {
  components: { formMonitor },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/monitor') }
  }
}
</script>

